import { render, staticRenderFns } from "./PagerComponent.vue?vue&type=template&id=1bbba7b1&scoped=true&"
import script from "./PagerComponent.vue?vue&type=script&lang=js&"
export * from "./PagerComponent.vue?vue&type=script&lang=js&"
import style0 from "./PagerComponent.vue?vue&type=style&index=0&id=1bbba7b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbba7b1",
  null
  
)

export default component.exports